import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { getPortfolioCategory } from '../../api'
import ProductShowcase from './ProductShowcase'

function Co2liquefaction() {
  const [products, setProducts] = useState([])

  useEffect(() => {
    getPortfolioCategory('co2_liquefaction')
      .then(data => setProducts([...data].sort((a, b) => (b.specs.capacityTPD || 0) - (a.specs.capacityTPD || 0))))
      .catch(() => {})
  }, [])

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>CO₂ / N₂O: Liquefaction</Typography>
          <Typography className='page-subtitle'>
            Refrigeration units for CO₂ recovery and generation plants.
          </Typography>
        </div>

        <div className='page-stack'>
          {products.map((p, i) => (
            <ProductShowcase
              key={i}
              title={p.specs.name}
              images={p.image_paths}
              specs={[
                { label: 'Location', value: p.specs.location },
                { label: 'Capacity', value: p.specs.capacityTPD ? `${p.specs.capacityTPD} TPD` : '' },
                { label: 'Compressor', value: p.specs.compressor },
                { label: 'Refrigerant', value: p.specs.refrigerant },
                { label: 'Controller', value: p.specs.controller },
              ]}
              badges={[
                p.specs.water_cooled_condenser && 'Water-cooled condenser',
                p.specs.remote && 'Smartphone / PC control',
                p.specs.under_production && 'Under production / installation',
              ]}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Co2liquefaction
